<template>
  <Menubar :model="items" breakpoint="4000px">
    <template #start>
      <NuxtLink
        v-if="tournamentsStore.activeTournament"
        to="/"
        class="navbar-tournament"
      >
        {{ tournamentsStore.activeTournament.name }}
      </NuxtLink>
    </template>
    <template #item="{ item, props, hasSubmenu }">
      <router-link
        v-if="item.link"
        v-slot="{ href, navigate }"
        :to="item.link"
        custom
      >
        <a v-ripple :href="href" v-bind="props.action" @click="navigate">
          <span :class="item.icon" />
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </router-link>
      <a
        v-else
        v-ripple
        :href="item.url"
        :target="item.target"
        v-bind="props.action"
      >
        <span :class="item.icon" />
        <span class="ml-2">{{ item.label }}</span>
        <span v-if="hasSubmenu" class="ph ph-caret-down ml-2" />
      </a>
    </template>

    <template #end>
      <router-link to="/user/profile" v-slot="{ href, navigate }" custom>
        <div class="flex align-items-center gap-2" @click="navigate">
          <!-- TODO add user info Avatar here -->
          <template v-if="usersStore.currentUser?.player?.booking_id">
            <!-- :image="usersStore.currentUser?.avatar" -->
            <Avatar
              :label="usersStore.currentUser?.player?.booking_id?.toString()"
              shape="circle"
              class="navbar-avatar"
            />
          </template>
        </div>
      </router-link>
    </template>
  </Menubar>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const pb = usePocketBase();
const usersStore = useUsersStore();
const tournamentsStore = useTournamentsStore();
const items = computed(() => [
  {
    label: 'home',
    icon: 'ph ph-house',
    link: '/',
  },
  {
    label: 'tournament',
    icon: 'ph ph-star',
    link: '/tournament',
  },
  // discgolf pages - course, tournament
  {
    label: 'discgolf',
    icon: 'ph ph-tag',
    items: [
      // overview
      {
        label: 'overview',
        icon: 'ph ph-chart-bar',
        link: '/discgolf',
      },
      {
        label: 'course',
        icon: 'ph ph-map-trifold',
        link: '/discgolf/course',
      },
      {
        label: 'tournament',
        icon: 'ph ph-calendar',
        link: '/discgolf/tournament',
      },
    ],
  },
  // Map
  {
    label: 'map',
    icon: 'ph ph-map-trifold',
    link: '/map',
  },
  // Schedule
  {
    label: 'schedule',
    icon: 'ph ph-calendar',
    link: '/schedule',
  },
  // Timeline
  {
    label: 'timeline',
    icon: 'ph ph-clock',
    link: '/timeline',
  },
  // Lost & Found
  {
    label: 'lost & found',
    icon: 'ph ph-tray',
    visible: !!usersStore.currentUser,
    link: '/lost-found',
  },
  // Booking
  {
    label: 'booking',
    icon: 'ph ph-shopping-cart',
    link: '/booking',
    visible:
      !!usersStore.currentUser?.roles?.includes('booker') ||
      !!usersStore.currentUser?.roles?.includes('admin'),
  },
  // Login
  {
    label: 'login',
    icon: 'ph ph-sign-in',
    link: '/user/login',
    visible: !usersStore.currentUser,
  },
  // Profile
  {
    label: 'profile',
    icon: 'ph ph-user',
    link: '/user/profile',
    visible: !!usersStore.currentUser,
  },
  {
    label: 'admin',
    icon: 'ph ph-lock',
    visible: !!usersStore.currentUser?.roles?.includes('admin'),
    link: '/admin',
  },
  {
    label: 'new spirit',
    icon: 'ph ph-heart',
    link: `/new-spirit`,
  },

  {
    label: 'teammanager',
    icon: 'ph ph-crown',
    visible: !!usersStore.isActiveTeammanager,
    items: [
      {
        label: 'overview',
        icon: 'ph ph-chart-bar',
        link: `/teammanager`,
      },
      {
        label: 'players',
        icon: 'ph ph-hard-drive',
        link: `/teammanager/players`,
      },
      {
        label: 'new spirit',
        icon: 'ph ph-heart',
        link: `/new-spirit`,
      },
      {
        label: 'spirit overview',
        icon: 'ph ph-pencil-simple',
        link: `/teammanager/spirit-overview`,
      },
      {
        label: 'settlement',
        icon: 'ph ph-money',
        link: `/teammanager/settlement`,
      },
      {
        separator: true,
      },
    ],
  },
  {
    label: 'stats',
    icon: 'ph ph-chart-bar',
    visible: !!usersStore.currentUser?.roles?.includes('stats'),
    items: [
      {
        label: 'Bierzelt',
        icon: 'ph ph-beer-stein',
        link: '/stats?name=bierzelt',
      },
    ],
  },
  // al pages - overview, helferlist, saladlist only for admin and worker
  {
    label: 'ars ludendi internal',
    icon: 'ph ph-crown',
    visible:
      !!usersStore.currentUser?.roles?.includes('worker') ||
      !!usersStore.currentUser?.roles?.includes('admin'),
    items: [
      {
        label: 'overview',
        icon: 'ph ph-chart-bar',
        link: '/al',
      },
      {
        label: 'helferlist',
        icon: 'ph ph-hard-drive',
        link: `/al/helperjobs`,
      },
      {
        label: 'foods',
        icon: 'ph ph-pencil-simple',
        link: `/al/foods`,
      },
      {
        label: 'jingles',
        icon: 'ph ph-music-notes',
        link: `/jingles`,
      },
      {
        separator: true,
      },
    ],
  },
  {
    label: 'settings',
    icon: 'ph ph-gear',
    link: '/settings',
  },
  // Logout
  {
    label: 'logout',
    icon: 'ph ph-sign-out',
    link: '/',
    visible: !!usersStore.currentUser,
    command: () => {
      pb.authStore.clear();
      usersStore.refreshCurrentUser();
      location.reload();
      router.push('/');
    },
  },
]);
</script>
